import { render } from "./NewBrandTyreRange.vue?vue&type=template&id=9dbc70e4"
import script from "./NewBrandTyreRange.vue?vue&type=script&lang=js"
export * from "./NewBrandTyreRange.vue?vue&type=script&lang=js"

import exportComponent from "/Users/marc.bush/Sites/ensotyres/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__